import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, UnAuthGuard } from '@core/guards';
import { AppLayoutComponent } from '@layout/app.layout.component';
import { LoginComponent } from '@modules/auth/pages/login/login.component';
import { ForgotPasswordComponent } from '@modules/auth/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '@modules/auth/pages/reset-password/reset-password.component';
import { QueryParamGuard } from '@modules/auth/guards/query-param.guard';
import { WelcomeComponent } from '@shared/components/welcome/welcome.component';
import { ModulePermissionGuard } from '@core/guards/module-permission.guard';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: WelcomeComponent,
      },
      {
        path: 'profile',
        data: { breadcrumb: 'Profile' },
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'report',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Report' },
        loadChildren: () => import('@modules/report/report.module').then((m) => m.ReportModule),
      },
      {
        path: 'reviews',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Reviews' },
        loadChildren: () => import('@modules/reviews/reviews.module').then((m) => m.ReviewsModule),
      },
      {
        path: 'brand',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Brand.com' },
        loadChildren: () => import('@modules/brand/brand.module').then((m) => m.BrandModule),
      },
      {
        path: 'media',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Paid Media' },
        loadChildren: () =>
          import('@modules/paid-media/paid-media.module').then((m) => m.PaidMediaModule),
      },
      {
        path: 'social',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Social' },
        loadChildren: () => import('@modules/social/social.module').then((m) => m.SocialModule),
      },
      {
        path: 'ai',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Artificial Intelligence (AI)' },
        loadChildren: () => import('@modules/ai/ai.module').then((m) => m.AiModule),
      },
      {
        path: 'users',
        canActivate: [AuthGuard, ModulePermissionGuard],
        data: { breadcrumb: 'Users' },
        loadChildren: () => import('@modules/user/user.module').then((m) => m.UserModule),
      },
      // {
      //   path: 'master',
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: 'Master' },
      //   loadChildren: () => import('@modules/master/master.module').then((m) => m.MasterModule),
      // },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [UnAuthGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [UnAuthGuard],
  },
  {
    path: 'reset-password',
    canActivate: [QueryParamGuard],
    component: ResetPasswordComponent,
  },
  {
    path: '**',
    redirectTo: '/brand/channel-mix',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
